import { Action, Actions, AvailableModalActions, Error, State } from './store';

const initialState = {
  isModalOpen: false,
  currentModalAction: AvailableModalActions.SELECT_ACTIONS,

  send: {
    isSuccess: false,
    isPending: false,
    errors: [],
  },

  validateDataAction: {
    isPending: false,
    isSuccess: false,
    errors: null,
  },

  reviewAction: {
    isModalOpen: false,
  },
};

const reducer = (state: State = initialState, action: Action) => {
  const map = new Map([
    /* Common actions */
    [
      Actions.RESET,
      () => ({
        ...initialState,
      }),
    ],

    /* Modal actions */
    [
      Actions.SET_MODAL_IS_OPEN,
      () => ({
        ...state,
        isModalOpen: action.payload as boolean,
      }),
    ],
    [
      Actions.SET_MODAL_SCREEN,
      () => ({
        ...state,
        currentModalAction: action.payload as AvailableModalActions,
      }),
    ],

    /* Send to pepper actions */
    [
      Actions.SET_SEND_IN_PROGRESS,
      () => ({
        ...state,
        send: {
          isPending: true,
          isSuccess: false,
          errors: [],
        },
      }),
    ],
    [
      Actions.SET_SEND_ERRORS,
      () => ({
        ...state,
        send: {
          isPending: false,
          isSuccess: false,
          errors: action.payload as Error[],
        },
      }),
    ],
    [
      Actions.SET_SEND_SUCCESS,
      () => ({
        ...state,
        send: {
          isPending: false,
          isSuccess: true,
          errors: [],
        },
      }),
    ],

    /* Verification actions */
    [
      Actions.VALIDATE_IN_PROGRESS,
      () => ({
        ...state,
        validateDataAction: {
          isPending: true,
          isSuccess: false,
          errors: [],
        },
      }),
    ],
    [
      Actions.VALIDATE_ERRORS,
      () => ({
        ...state,
        validateDataAction: {
          isPending: false,
          isSuccess: false,
          errors: action.payload,
        },
      }),
    ],
    [
      Actions.VALIDATE_SUCCESS,
      () => ({
        ...state,
        validateDataAction: {
          isPending: false,
          isSuccess: true,
          errors: null,
        },
      }),
    ],

    [
      Actions.REVIEW_START,
      () => ({
        ...state,
        reviewAction: {
          isModalOpen: true,
        },
      }),
    ],
  ]);

  const actionCallback = map.get(action.type);

  return actionCallback ? actionCallback() : state;
};

export default reducer;
